import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrNotificationService } from 'src/app/service/toastr-notification.service';
import { UsersService } from 'src/app/service/users.service';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'companyName',
    'username',
    'address',
    'phone',
    'appVersion',
    'image',
    'action',
  ];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  environmentURL = environment.apiUrl;
  spinner: boolean = true;
  totalRecords: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;

  searchControl = new FormControl('');

  constructor(
    private userService: UsersService,
    private router: Router,
    private titleService: Title,
    private toastr: ToastrNotificationService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('User List');
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    // Subscribe to pagination changes
    this.paginator.page.subscribe((event) => {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.getAllUsers();
    });

    setTimeout(() => {
      this.getAllUsers();
    });
  }

  applyFilter() {
    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getAllUsers();
  }

  clearFilters() {
    this.searchControl.setValue('');
    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getAllUsers();
  }

  hasActiveFilters(): boolean {
    return !!this.searchControl.value?.trim();
  }

  getAllUsers() {
    this.spinner = true;
    const filters: any = {
      page: this.pageIndex + 1,
      pageSize: this.pageSize,
    };

    if (this.searchControl.value) filters.search = this.searchControl.value;

    this.userService.getUsersWithFilters(filters).subscribe({
      next: async (response) => {
        const users = response.users || response.data || [];
        this.dataSource = await new MatTableDataSource(users);
        if (response.pagination && response.pagination.totalUsers !== undefined) {
          this.totalRecords = response.pagination.totalUsers;
        } else if (response.total !== undefined) {
          this.totalRecords = response.total;
        } else if (response.totalRecords !== undefined) {
          this.totalRecords = response.totalRecords;
        } else {
          this.totalRecords = users.length;
        }
        this.spinner = false;
      },
      error: (error) => {
        this.spinner = false;
        this.toastr.error(
          error.message ? error.message : 'Could not load Users',
          'Error'
        );
      },
      complete: () => { },
    });
  }

  addUser() {
    this.router.navigate(['/addUser']);
  }

  onDelete(id: string) {
    this.userService.deleteUser(id).subscribe({
      next: (data) => {
        this.getAllUsers();
      },
      error: (error) => {
        this.toastr.error(
          error.message ? error.message : 'Could not delete user',
          'Error'
        );
      },
      complete: () => { },
    });
  }

  onEdit(id: string) {
    this.router.navigate(['/editUser/', id]);
  }
}
